// ============================================================
// USPATIH GO — Confirm Dialog (ganti window.confirm native)
// Berlaku global: user, kasir, creator, shop, dashboard
// ============================================================

const VARIANTS = {
  danger: {
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>`,
    ring: 'confirm-dialog__icon--danger',
    button: 'confirm-dialog__btn--danger',
  },
  warning: {
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>`,
    ring: 'confirm-dialog__icon--warning',
    button: 'confirm-dialog__btn--warning',
  },
  primary: {
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>`,
    ring: 'confirm-dialog__icon--primary',
    button: 'confirm-dialog__btn--primary',
  },
};

let activeDialog = null;

function normalizeOptions(input, extra = {}) {
  if (typeof input === 'string') {
    return { message: input, ...extra };
  }
  return { ...input, ...extra };
}

/**
 * @param {string|object} options
 * @returns {Promise<boolean>}
 */
export function confirmDialog(options = {}) {
  const opts = normalizeOptions(options, {
    title: 'Konfirmasi',
    message: 'Lanjutkan tindakan ini?',
    confirmText: 'Ya, Lanjutkan',
    cancelText: 'Batal',
    variant: 'primary',
  });

  const variant = VARIANTS[opts.variant] || VARIANTS.primary;

  return new Promise((resolve) => {
    if (activeDialog) {
      activeDialog.close(false);
    }

    let closed = false;

    const overlay = document.createElement('div');
    overlay.className = 'confirm-overlay';
    overlay.setAttribute('role', 'presentation');

    overlay.innerHTML = `
      <div class="confirm-dialog" role="alertdialog" aria-modal="true" aria-labelledby="confirm-dialog-title" aria-describedby="confirm-dialog-message">
        <button type="button" class="confirm-dialog__close" data-cancel aria-label="Tutup">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
        </button>
        <div class="confirm-dialog__icon ${variant.ring}" aria-hidden="true">${variant.icon}</div>
        <h3 id="confirm-dialog-title" class="confirm-dialog__title"></h3>
        <p id="confirm-dialog-message" class="confirm-dialog__message"></p>
        <div class="confirm-dialog__actions">
          <button type="button" class="confirm-dialog__btn confirm-dialog__btn--cancel" data-cancel></button>
          <button type="button" class="confirm-dialog__btn ${variant.button}" data-confirm></button>
        </div>
      </div>
    `;

    overlay.querySelector('.confirm-dialog__title').textContent = opts.title;
    overlay.querySelector('.confirm-dialog__message').textContent = opts.message;
    overlay.querySelector('.confirm-dialog__btn--cancel').textContent = opts.cancelText;
    overlay.querySelector('[data-confirm]').textContent = opts.confirmText;

    const close = (result) => {
      if (closed) return;
      closed = true;
      document.removeEventListener('keydown', onKey);
      overlay.classList.remove('confirm-overlay--show');
      overlay.classList.add('confirm-overlay--hide');
      activeDialog = null;
      setTimeout(() => {
        overlay.remove();
        document.body.classList.remove('confirm-open');
        resolve(result);
      }, 180);
    };

    activeDialog = { close };

    const onKey = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        close(false);
      }
    };

    overlay.querySelectorAll('[data-cancel]').forEach((btn) => {
      btn.addEventListener('click', () => close(false));
    });

    overlay.querySelector('[data-confirm]').addEventListener('click', () => close(true));

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close(false);
    });

    document.addEventListener('keydown', onKey);
    document.body.classList.add('confirm-open');
    document.body.appendChild(overlay);

    requestAnimationFrame(() => {
      overlay.classList.add('confirm-overlay--show');
      overlay.querySelector('[data-confirm]')?.focus();
    });
  });
}

/** Alias singkat — await confirmAction('pesan') */
export function confirmAction(message, options = {}) {
  return confirmDialog(normalizeOptions(message, options));
}

window.confirmDialog = confirmDialog;
window.confirmAction = confirmAction;
